import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CrossIcon from '@material-ui/icons/Close';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

export const ModalHeader = ({ className, title, CloseIcon = CrossIcon, onClose, theme, ...rest }) => (
    <DialogTitle
        className={ classnames({
            [theme.header]: true,
            [className]: !!className,
        }) }
        classes={{ root: theme.root }}
        disableTypography
        { ...rest }
    >
        { title }
        { onClose && (
            <IconButton onClick={ onClose }>
                <CloseIcon />
            </IconButton>
        ) }
    </DialogTitle>
);

ModalHeader.propTypes = {
    className: PropTypes.string,
    CloseIcon: PropTypes.element,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onClose: PropTypes.func,
    theme: PropTypes.shape({}),
};

export default ModalHeader;
